export const GOOGLE_MAPS_APIKEY = "AIzaSyAQq_HU2w_0du7AGygyrPF9sRiC6sCpCXU";
export const MAP_TILER_APIKEY = "HTzaaRoWrsqZfRG5JvI3";
export const dsn = "https://a9d2ebcfe09640a4971ce38d6b84d4ba@o426470.ingest.sentry.io/5390939";

export const COLORS = {
    primary: "#123d5c",
    lightPrimary: "#c4cfd6"
}